var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',{attrs:{"title":"Indicatori generali di digitalizzazione","titleSize":_vm.titleSize,"icon":"it-calendar","id":"watcher-area-general-indicators"}},[_c('quantitative-indicators'),_c('qualitative-indicators',{staticClass:"spacing-margin"}),_c('collaboration-indicators',{staticClass:"spacing-margin"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }